module.exports = __webpack_public_path__ + "img/bg_avatar_female_82.6007df90.png";